import { useTheme } from '@mui/material/styles';
import { colors } from '../../../../theme/colors';

export function useCardTitleColor() {
  const theme = useTheme();
  // Design: option card titles use #4D4D4D, which has no semantic token.
  return theme.palette.mode === 'dark'
    ? theme.palette.semantic.text.title2
    : colors.neutral[700];
}
